module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="image-tag-container">\n  ';
 if (editable) { ;
__p += '\n      <div contenteditable="true" class="name"></div>\n      <button type="button" class="delete">\n          <span class="glyphicon glyphicon-remove"></span>\n      </button>\n  ';
 } else { ;
__p += '\n      <div class="name"></div>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/assets/image/tags/ImageTagItemView.tpl
// module id = 1732
// module chunks = 0